// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6630 ? "SeoPages" : chunkId) + "_" + {"2425":"f65f13027dc9c12b","6630":"f9b7faa15294570e"}[chunkId] + ".css";
};